import { IdentityPortrayalType, NoDocumentDataWithId, SingleDynamicDocumentData } from "@/legacy/models/shared";

export interface DelegatedNoDocumentDataWithId extends NoDocumentDataWithId {
  username: string;
  image: string;
  deliver_by_mail: boolean;
  acs_id: string;
}

export interface DelegatedOnboardingRequest {
  type: IdentityPortrayalType.selfie;
  data: DelegatedNoDocumentDataWithId | SingleDynamicDocumentData;
  acsIdSchema: string;
}

export enum DelegatedOnboardingResponseErrorCode {
  Unknown = "delegated-onboarding-error.unknown",
  DocumentExpired = "delegated-onboarding-error.document-expired",
  EmbeddingFailed = "delegated-onboarding-error.embedding-failed",
  IdAlreadyUsed = "delegated-onboarding-error.id-already-used",
  QrGenerationFailed = "delegated-onboarding-error.qr-generation-failed",
}

export interface DelegatedOnboardingResponseOk {
  success: true;
}

export interface DelegatedOnboardingResponseKo {
  success: false;
  code: DelegatedOnboardingResponseErrorCode;
}

export type DelegatedOnboardingResponse = DelegatedOnboardingResponseOk | DelegatedOnboardingResponseKo;

export interface GetAcsidStatusRequest {
  acsid: string;
}

export interface GetEmailStatusRequest {
  email: string;
}

export enum DelegatedOnboardingImageConstraints {
  MaxImageLength = 6990508,
  MinImageLength = 6828,
  DesiredImageLength = 6500000,
}
